<!--
	@修改人：黎柏祺
    @修改时间：2018-12-07
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 谢汉
    @创建时间: 2018-08-07
    @版本:v1.0.20
    @描述: 应用管理-分组管理
    -->
<template>
  <div class="groupManager__content">
    <g-back :history="history"></g-back>
    <div style="margin-bottom: 16px;">
      <el-button type="primary"
        @click="createGroup"
        v-g-rac="gRac('groupManager@create')">{{$t('appManager.create')}}</el-button>
    </div>
    <div>
      <el-form ref="form"
        :model="form"
        :inline="true"
        input-width="auto">
        <el-form-item :label="$t('agentManage.siteCode')">
          <g-select v-model="form.siteCode"
            :list="select_site"
            :default-all="true"></g-select>
        </el-form-item>
        <el-form-item label="GROUP">
          <g-select :list="select_group"
            v-model="form.name"
            :default-all="true"></g-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary"
            @click="e_search"
            v-g-rac="gRac('groupManager@search')">{{ $t('common.search') }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-table-extend :data="tData"
        :head="tHead"
        :currentChange="tCurrentChange"
        :sizeChange="tSizeChange"
        border>
        <template slot="control-column"
          slot-scope="{data}">
          <el-table-extend-control :control="tableControl"
            :data="data"
            :label="$t('common.handle')">
          </el-table-extend-control>
        </template>
      </el-table-extend>
    </div>
    <dialog-form key="groupEdit"
      :title="dialogTitle"
      :size="1"
      :label-size="2"
      :visible.sync="dialogFormShow"
      :model="dialogModel"
      :input-data="dialogData"
      :rules="dialogFormRule"
      :confirm-fun="e_save">
    </dialog-form>
  </div>
</template>
<script>
import rac from "@/plugins/rac-mixin";
import dic from "@/components/mixins/dic";
import table from "@/components/mixins/table";
import appManagerBiz from "@/logic/cmdb/appManagerBiz";
import dialogForm from "@/components/dialogForm";
import SiteListBiz from "@/logic/cmdb/cmdbBiz";
import dutyManagementBiz from "@/logic/statistics/dutyManagementBiz";
import validateConfig from "@/utils/validate";
import { extend } from "@/utils/tool";
export default {
  mixins: [rac, table, dic],
  data() {
    const that = this;
    return {
      form: {
        siteCode: "",
        name: ""
      },
      isAmend: false,
      select_group: {},
      select_site: {},
      dialogTitle: "",
      dialogFormShow: false,
      dialogModel: {},
      dialogData: [],
      dialogFormRule: {},
      tableControl: [
        {
          label: that.$t("common.edit"),
          callback: that.e_edit,
          rac: () => that.gRac("appManager@amend")
        },
        {
          label: that.$t("common.delete"),
          callback: that.e_delete,
          rac: () => that.gRac("appManager@delete")
        }
      ],
      history: [],
      initFlag: true
    };
  },
  components: {
    dialogForm
  },
  methods: {
    init() {
      this.history = [];
      this.history.push({
        name: this.$t("appManager.groupManager"),
        path: "/home/appManager"
      });
      this.getSiteList();
    },
    getSiteList() {
      SiteListBiz.siteList({ perPageCount: 500 }).then(data => {
        let list = {};
        data.dataList.map(item => {
          list[item.siteCode] = item.name;
        });
        this.select_site = list;
        this.waitGroupList();
        this.search();
      });
    },
    async waitGroupList(siteCode, siteChange) {
      await this.dGetGroup(siteCode, siteChange);
      await dutyManagementBiz.getUsers().then(data => {
        let res = {};
        data.map(item => {
          res[item.userName] = item.userName;
        });
        this.operators_list = { ...res };
      });
      this.select_group = { ...this.dDictionaryGroup };
      console.log(this.select_group);
      if (!this.initFlag) return;
      this.initFlag = false;
      this.initTable();
      this.setDialogData();
    },
    initTable() {
      this.tInitTable({
        lanKey: "appManager.table",
        head: ["siteCode", "name", "desc", "operations"],
        requestFun: this.search,
        headOpt: {
          siteCode: {
            formatter: "Dictionary",
            formatterDic: this.select_site
          }
        }
      });
    },
    setDialogData() {
      this.dialogData = [
        {
          label: this.$t("agentManage.siteCode"),
          key: "siteCode",
          type: "select",
          select: this.select_site
        },
        {
          label: "GROUP",
          key: "name"
        },
        {
          label: this.$t("appManager.remark"),
          key: "desc"
        },
        {
          label: this.$t("appManager.operations"),
          key: "operations",
          type: "select",
          select: this.operators_list
        }
      ];
      this.dialogFormRule = {
        name: [{ ...validateConfig.common.notEmpty }]
      };
    },
    search() {
      const reqData = extend(true, { ...this.tPageInfo }, this.form);
      Object.keys(reqData).map(item => {
        if (reqData[item] === "") {
          delete reqData[item];
        }
      });
      appManagerBiz.findAllGroupList(reqData).then(data => {
        this.tData = data;
      });
    },
    e_search() {
      this.tResetPage();
      this.search();
    },
    e_edit(rowData) {
      this.isAmend = true;
      this.openGroupDialog(rowData);
    },
    e_delete(rowData) {
      this.$confirm(this.$t("common.deleteTips"), this.$t("common.tips"), {
        type: "warning"
      })
        .then(() => {
          appManagerBiz
            .deleteGroup({
              id: rowData.id
            })
            .then(data => {
              this.$message({
                message: this.$t("common.success"),
                type: "success"
              });
              this.search();
              this.waitGroupList(this.form.siteCode, true);
            });
        })
        .catch(() => {});
    },
    e_save(data) {
      const _da = { ...data };
      if (!this.isAmend) {
        appManagerBiz.saveGroup(_da).then(() => {
          this.successCallBack();
        });
      } else {
        appManagerBiz.updateGroup(_da).then(() => {
          this.successCallBack();
        });
      }
    },
    successCallBack() {
      this.$message({
        message: this.$t("common.success"),
        type: "success"
      });
      this.search();
      this.dialogFormShow = false;
      this.waitGroupList(this.form.siteCode, true);
    },
    createGroup() {
      this.isAmend = false;
      this.openGroupDialog();
    },
    openGroupDialog(rowData) {
      this.dialogTitle = !this.isAmend
        ? this.$t("appManager.createGroup")
        : this.$t("appManager.editGroup");
      this.dialogFormShow = true;
      this.dialogModel = {
        siteCode: Object.keys(this.select_site)[0],
        name: "",
        desc: "",
        operations: ""
      };
      if (rowData) {
        this.dialogModel = { ...rowData };
        delete this.dialogModel.status;
      }
    }
  },
  watch: {
    "form.siteCode": function(val) {
      this.waitGroupList(val, true);
      this.form.name = "";
    }
  },
  mounted() {
    this.init();
  }
};
</script>
